import React from "react";
import { Row, Col } from "antd";
import { InputItem, DatePickerItem } from "../../../components/forms/FormItems";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import moment from "moment";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import {
  SettingsDataSelect,
  SubProjectsSelect,
  MetaDataSelect,
  BranchSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import { useLocation } from "react-router-dom";
import { isAllowedFeature } from "../../organization/organizationSlice";

const PatientPersonal = (props) => {
  const { values, branchId, referrerType, setReferrerType } = props;
  const { branch } = values;
  const branchNumber = branchId || branch;
  let location = useLocation();
  const disabledDate = (current) => {
    const startdate = moment();
    return current && current > startdate;
  };
  const defaultPickerValue = moment();

  const filterItems = (data) => {
    const filtered =
      values && values.referrer_id
        ? data.filter(
            (i) =>
              i.referrer_id === values.referrer_id &&
              i.branches.includes(+branchNumber)
          )
        : [];
    return filtered;
  };

  const filterReferrers = (items) => {
    const selected = items.find((i) => i.id === values?.referrer_id);
    setReferrerType(selected?.referrer_type);
    return items;
  };
  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={1}>
                <InputItem name="surename" category="patient" required={true} />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={2}>
                <InputItem
                  name="first_name"
                  category="patient"
                  required={true}
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={3}>
                <InputItem
                  name="local_id_number"
                  id={true}
                  category="patient"
                />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={4}>
                <DatePickerItem
                  name="birthday"
                  category="patient"
                  disabledDate={disabledDate}
                  defaultPickerValue={defaultPickerValue}
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={5}>
                <MetaDataSelect
                  name="family_status_id"
                  category="patient"
                  metadataName="family_status"
                />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={6}>
                <SettingsDataSelect
                  name="languages"
                  category="patient"
                  settingsdataName={"system_tables/languages"}
                  mode="multiple"
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          {isAllowedFeature("accounting_tag") && branchNumber && (
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="branch_extension_id"
                  category="patient"
                  settingsdataName={"system_tables/branch_extensions"}
                  filterItems={(data) =>
                    data.filter((i) => i.branch_id === +branchNumber)
                  }
                  required={isAllowedFeature("accounting_tag")}
                />
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={6}>
                  <SubProjectsSelect
                    name="subproject_id"
                    category="patient"
                    branchId={+branchNumber}
                    required={isAllowedFeature("accounting_tag")}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>
          )}

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={7}>
                <RadioButtonItem
                  required={true}
                  name="gender_id"
                  category="patient"
                  genders={true}
                  translated={true}
                />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={8}>
                {location.pathname.includes("admin") ? (
                  <AnimationChildWrapper itemKey={4}>
                    <BranchSelect
                      name="branch"
                      category="patient"
                      required={true}
                    />
                  </AnimationChildWrapper>
                ) : null}
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          {process.env.REACT_APP_CONFIG === "matav" && (
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={7}>
                  <SettingsDataSelect
                    name={"referrer_id"}
                    category={"references"}
                    required={true}
                    settingsdataName={"system_tables/referrer"}
                    filterItems={filterReferrers}
                  />
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={8}>
                  {referrerType === "employees" ? (
                    <EmployeesSelect
                      name={"employee_id"}
                      category={"references"}
                      required={true}
                      extraParams={{ filter: {} }}
                      showFullEmplyeeInfo
                    />
                  ) : (
                    <SettingsDataSelect
                      name={"sub_referrer_id"}
                      category={"references"}
                      required={true}
                      settingsdataName={"system_tables/sub_referrer"}
                      filterItems={filterItems}
                    />
                  )}
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>
          )}
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default PatientPersonal;
